<button
  mat-icon-button
  type="button"
  (click)="click($event)"
  [matTooltip]="tooltip">
  <mat-icon>qr_code_2</mat-icon>
</button>
